module.exports = __webpack_public_path__ + "img/22.45332f50.png";